// Constants
const codeStringsBaseUrl = "api/productcodestringsegments"
const motorsBaseUrl = "api/productmotor";
const productTypesBaseUrl = "api/producttype";
const unitSizeBaseUrl = "api/productunitsize";
const voltageBaseUrl = "api/voltage";
const productVoltageBaseUrl = "api/productvoltage";

// Export Structure
export const apiUrls = {
  codestrings: codeStringsBaseUrl,
  motors: motorsBaseUrl,
  productTypes: productTypesBaseUrl,
  unitSizes: unitSizeBaseUrl,
  voltages: voltageBaseUrl,
  productVoltages: productVoltageBaseUrl,
};
